import { render, staticRenderFns } from "./CrTekyeDestination.vue?vue&type=template&id=5203b484&"
import script from "./CrTekyeDestination.vue?vue&type=script&lang=js&"
export * from "./CrTekyeDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports